<template>
  <div>
    <!-- 图文，广告位 -->
    <div v-if="isType(news, [contentTypes.imageText, contentTypes.redirect])" class="swiper-slide">
      <img class="active-img" :src="news.generalView.mediaCover.split(',')[0]" :onerror="placeholderBg" alt="" />
      <div class="detail-group cf">
        <div class="detail-title">
          <h3 class="text-overflow text-overflow-title">
            {{ news.generalView && news.generalView.mediaTitle }}
          </h3>
          <div class="tag-content" style="margin-top: 8px">
            <p v-for="(tag, index) in tagsList" :key="'lebel' + index">
              <span
                v-if="tag"
                :class="[
                  'simple-module-item-tag',
                  index % 3 == 0
                    ? 'simple-module-item-tag--blue'
                    : index % 3 == 1
                    ? 'simple-module-item-tag--green'
                    : 'simple-module-item-tag--yellow'
                ]"
                >{{ tag }}</span
              >
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- 视频（短视频，长视频），货架内展示 -->
    <div v-else-if="isType(news, [contentTypes.longVideo, contentTypes.shortVideo]) && !listStyle" class="swiper-slide">
      <div class="video-tips">
        <i class="video-tips-pause"></i>
        <i class="video-tips-time"></i>
      </div>
      <img class="active-img" :src="news.generalView.mediaCover.split(',')[0]" :onerror="placeholderBg" alt="" />
      <div class="detail-group cf">
        <div class="detail-title">
          <h3 class="text-overflow text-overflow-title">{{ news.generalView && news.generalView.mediaTitle }}</h3>
          <div class="tag-content" style="margin-top: 8px">
            <p v-for="(tag, index) in tagsList" :key="'lebel' + index">
              <span
                v-if="tag"
                :class="[
                  'simple-module-item-tag',
                  index % 3 == 0
                    ? 'simple-module-item-tag--blue'
                    : index % 3 == 1
                    ? 'simple-module-item-tag--green'
                    : 'simple-module-item-tag--yellow'
                ]"
                >{{ tag }}</span
              >
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- 视频，列表页展示 -->
    <div v-else-if="isType(news, [contentTypes.longVideo, contentTypes.shortVideo]) && listStyle" class="video-item">
      <div class="video-tips video-item--player">
        <i class="video-tips-pause"></i>
        <i class="video-tips-time"></i>
        <img class="active-img" :src="news.generalView.mediaCover.split(',')[0]" :onerror="placeholderBg" alt="" />
      </div>
      <div class="detail-group cf">
        <div class="detail-title">
          <h3 class="text-overflow text-overflow-title">{{ news.generalView && news.generalView.mediaTitle }}</h3>
          <div class="text-overflow text-overflow-remark tag-content mod-list--new">
            <p v-for="(tag, index) in tagsList" :key="'lebel' + index">
              <span
                v-if="tag"
                :class="[
                  'simple-module-item-tag',
                  index % 3 == 0
                    ? 'simple-module-item-tag--blue'
                    : index % 3 == 1
                    ? 'simple-module-item-tag--green'
                    : 'simple-module-item-tag--yellow'
                ]"
                >{{ tag }}</span
              >
            </p>
            <span class="look-num"></span>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="swiper-slide">
      <img class="active-img" :src="placeholderBg" alt="加载中" />
      <div class="detail-group cf">
        <div class="detail-title">
          <h3 class="text-overflow text-overflow-title"></h3>
          <p class="text-overflow text-overflow-remark"><span class="news-name"></span> <span class="look-num"></span></p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { CONTENT_TYPES } from "../../../store/enums"
import { computed, reactive, toRefs } from "@vue/composition-api"
import useDetailItem from "../../mixins/useDetailItem"

export default {
  props: ["news", "listStyle"],
  setup(props, { root }) {
    const { isType } = useDetailItem(root)
    const data = reactive({
      contentTypes: CONTENT_TYPES,
      placeholderBg: require("../../../../ui/assets/mobile/images/placeholder-bg.png"),
      tagsList: computed(() => {
        if (props.news.generalView && props.news.generalView.mediaTags && props.news.generalView.mediaTags.length) {
          return props.news.generalView.mediaTags.map((mediaTag, index) => {
            if (mediaTag && mediaTag.TagWords && index < 3) {
              return mediaTag.TagWords
            }
            if (mediaTag && mediaTag.Status && mediaTag.Name && index < 3) {
              return mediaTag.Name
            }
          })
        } else {
          return []
        }
      })
    })

    return {
      ...toRefs(data),
      isType
    }
  }
}
</script>
